import Commons from '../../../../Services/Common/Common';

/**
 * SUB_BASIC_01 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 조회 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapParamsBySchema에 기본적으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다.
 */
export const SUB_BASIC_01_Schema = {
  fields: {
    custCd: { initial: '', label: '도급업체코드' },
    partnerCd: { initial: '', label: '수급업체코드' },
    mstCustCd: { initial: '', label: '사업장코드' },
    custNm: { initial: '', label: '업체명', required: 'Y' },
    content: { initial: '', label: '내용' },
    workNo: { initial: 0, label: '상시근로자수' },
    ceoTel: { initial: '', label: '대표자(연락처)', required: 'Y' },
    ceo: { initial: '', label: '대표자성명', required: 'Y' },
    custTel: { initial: '', label: '관리자(연락처)', required: 'Y' },
    custManageRank: { initial: '', label: '관리자직위', required: 'Y' },
    custManageNm: { initial: '', label: '관리자성명', required: 'Y' },
    remark: { initial: '', label: '비고' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    search2: {
      PartnerCd: (_, context) =>
        Commons.EncryptAES(context.partnerCd || '') || '',
      StartYear: (_, context) =>
        Commons.EncryptAES(context.search?.modalStartYear || '') || '',
      EndYear: (_, context) =>
        Commons.EncryptAES(context.search?.modalEndYear || '') || '',
    },
    search3: {
      SbmId: (_, context) => Commons.EncryptAES(context.sbmId || 0) || '',
      PartnerCd: (_, context) =>
        Commons.EncryptAES(context.partnerCd || '') || '',
    },
    save1: {
      MstCustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      CustCd: (row) => Commons.EncryptAES(row.partnerCd || '') || '',
      CustNm: (row) => Commons.EncryptAES(row.custNm || '') || '',
      Content: (row) => Commons.EncryptAES(row.content || '') || '',
      WorkNo: (row) => Commons.EncryptAES(row.workNo || '') || '',
      CeoTel: (row) => Commons.EncryptAES(row.ceoTel || '') || '',
      Ceo: (row) => Commons.EncryptAES(row.ceo || '') || '',
      CustTel: (row) => Commons.EncryptAES(row.custTel || '') || '',
      CustManageRank: (row) =>
        Commons.EncryptAES(row.custManageRank || '') || '',
      CustManageNm: (row) => Commons.EncryptAES(row.custManageNm || '') || '',
      Remark: (row) => Commons.EncryptAES(row.remark || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    save2: {
      SbmId: (row) => Commons.EncryptAES(row.sbmId || '') || '',
      SbmYear: (row) => Commons.EncryptAES(row.sbmYear || '') || '',
      SbmHalf: (row) => Commons.EncryptAES(row.sbmHalf || '') || '',
      PartnerCd: (row) => Commons.EncryptAES(row.partnerCd || '') || '',
      SbdId: (row) => Commons.EncryptAES(row.sbdId || '') || '',
      TotalScore: (row) => Commons.EncryptAES(row.totalScore || '0') || '',
      EvaluatorOpinion: (row) =>
        Commons.EncryptAES(row.evaluatorOpinion || '') || '',
      Grade: (row) => Commons.EncryptAES(row.grade || 'E') || '',
      DetailRows: (row) =>
        Commons.EncryptAES(JSON.stringify(row.detailRows || [])) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    delete1: {
      CustCd: (row) => Commons.EncryptAES(row.partnerCd || '') || '',
      PartnerCompany: (row) => Commons.EncryptAES(row.mstCustCd || '') || '',
    },
    delete2: {
      SbmId: (row) => Commons.EncryptAES(row.sbmId || '') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
